import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/content";
import { StarDash } from "@/components/StarDash";

const FAQSection = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="py-20 sm:py-32 bg-[#f1e7d7] border-y border-[#d9c9b2]"
  >
    <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-10">
      <div className="text-center reveal">
        <StarDash />
        <div className="mt-6 font-sans-body text-[11px] font-bold uppercase tracking-[0.32em] text-[#6b5a4a]">
          ★ Questions, Answered
        </div>
        <h2 className="font-display mt-4 text-4xl sm:text-6xl font-bold tracking-tight text-[#2b1a14] leading-[0.95]">
          Frequently
          <br />
          <span className="font-italic-serif text-[#c63027]">Asked.</span>
        </h2>
        <p className="font-italic-serif mt-5 text-base sm:text-lg text-[#5a4636]">
          Still curious? WhatsApp us directly — replies usually within the hour.
        </p>
      </div>

      <div className="mt-12 sm:mt-14">
        <Accordion
          type="single"
          collapsible
          className="border-t border-[#c63027]/40"
          data-testid="faq-accordion"
        >
          {FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#c63027]/40"
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger
                className="font-display text-left text-lg sm:text-2xl font-bold tracking-tight text-[#2b1a14] py-5 sm:py-6 hover:no-underline hover:text-[#c63027] [&[data-state=open]]:text-[#c63027]"
                data-testid={`faq-trigger-${i + 1}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5a4636] text-base sm:text-lg leading-relaxed pb-5 sm:pb-6 max-w-3xl">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQSection;
